import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

// localStorage.setItem('mode', false);

const App = () => {
    const themeMode = useSelector((state) => state?.theme?.mode);
    useEffect(() => {}, [themeMode]);

    // window.onbeforeunload = function () {
    //     localStorage.removeItem('token');
    //     return '';
    // };

    const navigate = useNavigate();

    // useEffect(() => {
    //     const inactivityTimer = setTimeout(() => {
    //         localStorage.removeItem('token');
    //         navigate('/');
    //     }, 10000);
    //     return () => {
    //         clearTimeout(inactivityTimer);
    //     };
    // });

    // useEffect(() => {
    //     console.log("text document", document.getElementById("root").innerText);
    //     // setTimeout(responsiveVoice.speak(text), 1500);
    //     responsiveVoice.speak(document.getElementById("root").innerText);
    // }, [document.getElementById("root").innerText])

    return (
        <ThemeConfig>
            <GlobalStyles />
            <Router />
        </ThemeConfig>
    );
};

export default App;
